export default "__VITE_ASSET__hWJSukF5__"